import React from 'react';
import GlobalStyles from './GlobalStyles';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import About from './components/About';
import Services from './components/Services';
import TowTruck from './components/TowTruck';
import Insurance from './components/Insurance';
import Location from './components/Location';
import Footer from './components/Footer';

function App() {
  return (
    <>
      <GlobalStyles />
      <Navbar />
      <Hero />
      <About />
      <Services />
      <TowTruck />
      <Insurance />
      <Location />
      <Footer />
    </>
  );
}

export default App;